// This file is needed because the publisher published garbage so we need to hack around because we need the component
/*
<script type="module" src="https://unpkg.com/@navsnpm/katex-expression/dist/katex-expression/katex-expression.esm.js"></script>
<script nomodule="" src="https://unpkg.com/@navsnpm/katex-expression/dist/katex-expression/katex-expression.js"></script>
*/
let initedOnce = false;
export function initKatexComponent() {
  if (initedOnce) return;
  const scriptTagModule = document.createElement('script');
  scriptTagModule.setAttribute('src', 'https://chancencampus.org/_katexesm/katex-expression.esm.js');
  scriptTagModule.setAttribute('type', 'module');
  document.head.appendChild(scriptTagModule);
  initedOnce = true;
}
